/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Unavailable_DescInputs */

const en_pc_online_unavailable_desc = /** @type {(inputs: Pc_Online_Unavailable_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our hosted copy is not live yet. Meanwhile, download the desktop app, or grab the web build and run it yourself.`)
};

const zh_pc_online_unavailable_desc = /** @type {(inputs: Pc_Online_Unavailable_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们托管的在线版暂未上线。在此期间，你可以下载桌面版，或下载网页版自行运行。`)
};

/**
* | output |
* | --- |
* | "Our hosted copy is not live yet. Meanwhile, download the desktop app, or grab the web build and run it yourself." |
*
* @param {Pc_Online_Unavailable_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_unavailable_desc = /** @type {((inputs?: Pc_Online_Unavailable_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Unavailable_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_unavailable_desc(inputs)
	return zh_pc_online_unavailable_desc(inputs)
});
export { pc_online_unavailable_desc as "pc.online.unavailable_desc" }